import { render } from "./SearchNews.vue?vue&type=template&id=29cf9910"
import script from "./SearchNews.vue?vue&type=script&lang=js"
export * from "./SearchNews.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\newspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__